// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kT1MMITUKyRGcf {
  grid-area: taxid;
}
.hZ7miasAKyoPay {
  grid-area: statetaxid;
}
.ia697qR24XTl57 input[type='text'] {
  height: 40px;
}
`, ""]);
// Exports
export var taxId = `kT1MMITUKyRGcf`;
export var stateTaxId = `hZ7miasAKyoPay`;
export var input = `ia697qR24XTl57`;
export default ___CSS_LOADER_EXPORT___;
